import { useSyncExternalStore } from "react";

/** What the googly-eyed mascot is doing: watching files come in, or reacting to a result. */
export type Mood = "idle" | "alert" | "happy" | "wink";

let held: Mood | null = null;
let flash: Mood | null = null;
let timer: ReturnType<typeof setTimeout> | null = null;
let current: Mood = "idle";
const listeners = new Set<() => void>();

const emit = () => {
  const next = flash ?? held ?? "idle";
  if (next === current) return;
  current = next;
  for (const listener of listeners) listener();
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useMood = () => useSyncExternalStore(subscribe, () => current);

/** Keeps a mood until it is released, as while files are dragged over the page. */
export const holdMood = (mood: Mood | null) => {
  held = mood;
  emit();
};

/** Shows a mood briefly, then settles back to whatever is held. */
export const flashMood = (mood: Mood, ms: number) => {
  if (timer !== null) clearTimeout(timer);
  flash = mood;
  timer = setTimeout(() => {
    timer = null;
    flash = null;
    emit();
  }, ms);
  emit();
};
